import { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';
import { Megaphone } from 'lucide-react';
import axios from 'axios';
import { API_URL } from '../lib/api';

export function AnnouncementPopup({ user }) {
  const [announcement, setAnnouncement] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const loadAnnouncements = async () => {
      if (!user) return;
      
      try {
        const token = localStorage.getItem('session_token');
        if (!token) return;
        
        const response = await axios.get(`${API_URL}/announcements/active`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        
        // Show the first undismissed announcement
        if (response.data && response.data.length > 0) {
          setAnnouncement(response.data[0]);
          setOpen(true);
        }
      } catch (error) {
        // Silently handle 401 errors - user may not be fully authenticated yet
        if (error?.response?.status !== 401) {
          console.error('Failed to load announcements:', error);
        }
      }
    };

    loadAnnouncements();
  }, [user]);

  const handleDismiss = async () => {
    if (!announcement) return;
    
    try {
      const token = localStorage.getItem('session_token');
      await axios.post(`${API_URL}/announcements/${announcement.id}/dismiss`, {}, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setOpen(false);
      setAnnouncement(null);
    } catch (error) {
      console.error('Failed to dismiss announcement:', error);
      setOpen(false);
    }
  };

  if (!announcement) return null;

  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && handleDismiss()}>
      <DialogContent className="max-w-2xl bg-parchment rounded-highlight shadow-modal">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-3 text-[28px] sm:text-[32px] font-normal leading-tight">
            <Megaphone className="w-[18px] h-[18px] text-clay shrink-0" />
            {announcement.title}
          </DialogTitle>
        </DialogHeader>
        <div className="py-4">
          <div className="max-w-none">
            <p className="whitespace-pre-wrap text-base text-foreground">{announcement.message}</p>
          </div>
        </div>
        <DialogFooter>
          <Button onClick={handleDismiss}>Got it</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
